enum ControlTypeEnum {
    checkbox = "checkbox",
    textInput = "textInput",
    numberInput = "numberInput",
    textArea = "textArea",
}

export default ControlTypeEnum;
